import { ChevronDown } from 'lucide-react';
import React, { useRef, useEffect, useState } from 'react';
import StyledMenu from '../MUIUtilities/StyledMenu';
import StyledCard from '../Cards/StyledCard';

// StatCard component (unchanged)
const StatCard = ({ cardBg = 'primary', title, value, icon: Icon, statistics }) => {
  const [currentStatistics, setCurrentStatistics] = useState('');
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(false);


  useEffect(() => {
    if (statistics?.monthly) {
      setCurrentStatistics(statistics.monthly);
    }
  }, [statistics])

  const handleDropDown = (e) => {
    setShow(e.currentTarget)
  }

  const handleSwitch = (type) => {
    setCurrentStatistics(statistics[type])
    setShow(null)
  }

  const dropdownComponents = [
    {
      onClick: () => handleSwitch("monthly"),
      content: () => {
        return (
          <p className='typography-large-p  w-full h-full rounded-xl flex items-center px-2'>
            Last Month
          </p>
        )
      }
    },
    {
      onClick: () => handleSwitch("weekly"),
      content: () => {
        return (
          <p className='typography-large-p  w-full h-full rounded-xl flex items-center px-2'>
            Last Week
          </p>)
      }
    },
    {
      onClick: () => handleSwitch("daily"),
      content: () => {
        return (
          <p className='typography-large-p  w-full h-full rounded-xl flex items-center px-2'>
            Last Day
          </p>
        )
      }
    }
  ]

  return (
    <StyledCard backgroundColor={cardBg === 'secondary' ? 'bg-background-80' : 'bg-background-100'} padding={2} extraStyles="flex  overflow-hidden justify-between relative items-center   min-w-[15rem] max-w-[15rem]">
      <div className=" w-full ">
        <p className="typography-small-p text-font-teritiary w-max mb-2">{title}</p>
        <h2 className="pb-2">{value ?? 0}</h2>
        {<p key={currentStatistics} onClick={currentStatistics ? handleDropDown : undefined} className={`typography-small-p min-h-[18px] relative z-[1] text-font-teritiary  flex items-center gap-1  ${currentStatistics ? "cursor-pointer" : ""}`}>
          <span className={/\-/.test(currentStatistics?.split(' ')[0]) ? 'text-red-40' : 'text-green-70'}>{currentStatistics && (/\-/.test(currentStatistics?.split(' ')[0]) || '+')}{currentStatistics?.split(' ')[0]}</span> {currentStatistics?.split(' ').slice(1).join(' ')}
          {
            currentStatistics &&
            <span><ChevronDown size={14} /></span>
          }

        </p>}
      </div>
      <div  className='absolute z-0 -right-5 -bottom-4'>
        <Icon />
      </div>
      <StyledMenu itemComponents={dropdownComponents} anchorEl={show} handleMenuClose={() => setShow(null)} />
    </StyledCard>
  )
};

// Updated StatsGrid component with horizontal mouse wheel scroll
const StatsGrid = ({ cardBg , stats }) => {
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const handleWheel = (e) => {
      if (scrollContainerRef.current) {
        e.preventDefault();
        scrollContainerRef.current.scrollLeft += e.deltaY;
      }
    };

    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener('wheel', handleWheel, { passive: false });
    }

    return () => {
      if (container) {
        container.removeEventListener('wheel', handleWheel);
      }
    };
  }, []);

  return (
    <div
      ref={scrollContainerRef}
      className="flex gap-4 overflow-x-auto scrollbar-hide"
      style={{
        msOverflowStyle: 'none',  /* IE and Edge */
        scrollbarWidth: 'none',   /* Firefox */
      }}
    >
      {stats.map((stat, index) => (
        <StatCard cardBg={cardBg} key={index} title={stat.title} value={stat.value} icon={stat.icon} statistics={stat.statistics} />
      ))}
    </div>
  );
};

export default StatsGrid;